module.exports = __webpack_public_path__ + "img/s1Bg.a09d20ea.webp";